export default [
  {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'telefone',
    label: 'Número de Telefone (com DDD)',
    info: 'Exemplo: 11999998888',
    rules: ['required']
  }
];



// WEBPACK FOOTER //
// ./src/components/apps/web/conta-whatsapp/_form/whatsapp-teste.js